export default "__VITE_ASSET__2e57f51f__"